import api from './api';
import type { Paginated, TripTemplate } from '../types/api';

export async function listTripTemplates(): Promise<TripTemplate[]> {
  const { data } = await api.get<Paginated<TripTemplate> | TripTemplate[]>('/trip-templates/');
  return Array.isArray(data) ? data : data.results;
}

export interface TripTemplatePayload {
  name: string;
  route: number;
  vehicle?: number | null;
  driver?: number | null;
  default_departure_time?: string | null;
}

export async function createTripTemplate(payload: TripTemplatePayload): Promise<TripTemplate> {
  const { data } = await api.post<TripTemplate>('/trip-templates/', payload);
  return data;
}

export async function deleteTripTemplate(id: number): Promise<void> {
  await api.delete(`/trip-templates/${id}/`);
}
